import React, { FC, useEffect, useState } from 'react'
import { BasicStatsItem } from '../index.styles';
import { useTranslation } from 'react-i18next';
import { NewBudgetTable } from '../new-budget.component';
import styled from 'styled-components';
import { Text } from '../../text.component';
import { INewBudgetData, INewBudgetItem } from '../right-menu.component';

type TableType = 'regions-and-cities' | 'regional';

interface IProps {
  type: TableType,
  data: INewBudgetData,
  kato: string;
}

const NewBudgetFullScreenTable = styled(NewBudgetTable) <{ type: TableType }>`
  background-color: var(--white);
  table-layout: auto;
  td {
    padding: 0.625rem 0.5rem;
  }

  .green {
    background-color: rgb(204, 255, 204);
  }

  .yellow {
    background-color: rgb(255, 255, 153);
  }

  ${({ type }) => type === 'regional' && `
      tbody tr:first-child {
        background-color: rgb(204, 255, 255);
        td {
          font-weight: 700;
        }
      }

  `}
`;

const fixedHeaders: Partial<Record<keyof INewBudgetItem, string>> = {
  'districtOrAdministator': 'admins',
  'katoOrCode': 'code',
}

const NewBudgetFullScreen: FC<IProps> = ({ type, data, kato }) => {
  const { t } = useTranslation();
  const [tableHeaders, setTableHeaders] = useState<(keyof INewBudgetItem)[]>([]);
  const [regionsAndCitiesData, setRegionsAndCitiesData] = useState<INewBudgetItem>();
  const [tableData, setTableData] = useState<INewBudgetItem[]>([]);

  const generateTableHeaders = () => {
    const initial = [
      'districtOrAdministator',
      'plan2025',
      'planOnFeb28',
      'executedOnFeb28',
      'executionPercentage',
      'remaining',
    ]

    const filtered = type === 'regions-and-cities' ? initial : ['katoOrCode', ...initial];
    setTableHeaders(filtered as (keyof INewBudgetItem)[]);
  }

  const generateTableBody = () => {
    if (type === 'regions-and-cities') {
      const foundInfo = data.budgetExecutionCard.find((item: INewBudgetItem) => item.districtOrAdministator === 'Районы и города');
      foundInfo && setRegionsAndCitiesData(foundInfo)
      setTableData(data.districtBudgetExecution);
    } else {
      const foundInfo = data.budgetExecutionCard.find((item: INewBudgetItem) => item.districtOrAdministator === 'Собственно-областной');
      if (foundInfo) {
        setTableData([foundInfo, ...data.provincialBudgetExecution.filter((item: INewBudgetItem) => item.districtOrAdministator !== 'Собственно-областной')]);
      } else {
        setTableData(data.provincialBudgetExecution);
      }
    }
  }

  useEffect(() => {
    generateTableHeaders();
    generateTableBody();
  }, [type, data]);


  return (
    <BasicStatsItem style={{
      width: '100%',
      height: '100%',
      marginTop: '1rem',
    }}>
      <NewBudgetFullScreenTable type={type}>
        <thead>

          <tr className='yellow'>
            {
              tableHeaders.map((header, index) => (
                <th key={index}>
                  <Text color='var(--text-color)' fontWeight={700} fontSize='0.875rem'>
                    {type === 'regions-and-cities' ? t(`new-budget.${header}`) : t(`new-budget.${fixedHeaders[header] || header}`)}
                  </Text>
                </th>
              ))
            }
          </tr>
          {type === 'regions-and-cities' && <tr className='green'>
            {
              regionsAndCitiesData && tableHeaders.map((header, index) => (
                <th key={index}>
                  <Text color='var(--text-color)' fontWeight={700} fontSize='0.875rem'>{header === 'districtOrAdministator' ? t(`new-budget.${type}`) : regionsAndCitiesData[header]?.toLocaleString('Ru')}</Text>
                </th>
              ))
            }
          </tr>}
        </thead>
        <tbody>
          {
            tableData.map((item, row_index) => (
              <tr key={row_index}>
                {
                  tableHeaders.map((header, index) => (
                    <td key={index}>
                      <Text
                        color='var(--text-color)'
                        fontWeight={(header === 'districtOrAdministator' || (type === 'regional' && row_index === tableData.length - 1))
                          ? 700
                          : 400}
                        fontSize='0.875rem'>
                        {item[header]?.toLocaleString('Ru')}
                      </Text>
                    </td>
                  ))
                }
              </tr>
            ))
          }
        </tbody>
      </NewBudgetFullScreenTable>
    </BasicStatsItem>
  )
}

export default NewBudgetFullScreen